import { createStore, applyMiddleware } from 'redux'
import rootReducer from './reducers'

import thunk from 'redux-thunk'
import logger from 'redux-logger'

const middlewares = [
  thunk,
  logger
]

export default createStore(
  rootReducer,
  applyMiddleware(...middlewares)
)



// WEBPACK FOOTER //
// ./src/store/store.js